<template>
<div class="site-header-wrap">
<nav id="site-navigation" class="has-branding main-navigation nav-align-right sub-menu-right" aria-label="Primary" itemtype="https://schema.org/SiteNavigationElement" itemscope>
  <div class="inside-navigation">
    <div class="navigation-branding">
      <div class="site-logo">
        <a href="/" title="GBWhatsApp" rel="home">
          <img class="header-image is-logo-image" alt="GBWhatsApp" src="../assets/home/GB.webp" title="GBWhatsApp">
        </a>
      </div>
      <p class="main-title" itemprop="headline">
        <a href="/" rel="home">
          GBApps
        </a>
      </p>
    </div>
    <ul v-show="isMenuClicked" id="menu-primary-menu" class="menu sf-menu mobile-menu-page">
      <li class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33">
        <a href="/">GBWhatsApp</a>
      </li>
      <li class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33" :class="{ 'mod-dropdown-open': isModOpen }">
        <a href="#" @click.prevent.stop="isModOpen = !isModOpen">MOD Apps <span class="arrow arrow-hollow" aria-hidden="true" /></a>
        <ul v-show="isModOpen" class="mobile-sub-menu">
          <li><a href="/fm-whatsapp/">FM WhatsApp</a></li>
          <li><a href="/jt-whatsapp/">JT WhatsApp</a></li>
          <li><a href="/yo-whatsapp/">YoWhatsApp</a></li>
          <li><a href="/og-whatsapp/">OG WhatsApp</a></li>
          <li><a href="/red-whatsapp/">Red WhatsApp</a></li>
        </ul>
      </li>
      <li class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33">
        <a href="/download/" class="download-btn">Download</a>
      </li>
    </ul>

    <div id="primary-menu" class="main-nav">
      <!-- mobile -->
      <div v-if="$global.isMobileDevice()" class="mobile-menu">
        <div class="menu-toggle" @click="isMenuClicked=!isMenuClicked">
          <img v-if="!isMenuClicked" src="@/assets/menu.svg" alt="menu button">
          <img v-else src="@/assets/xmark-black.svg" alt="close button">
        </div>
      </div>
      <!-- pc -->
      <ul v-else id="menu-primary-menu" class="menu sf-menu">
        <li class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33">
          <a href="/">GBWhatsApp</a>
        </li>
        <li class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33 has-dropdown">
          <a href="#" @click.prevent>MOD Apps <span class="arrow arrow-hollow" aria-hidden="true" /></a>
          <ul class="dropdown-menu">
            <li><a href="/fm-whatsapp/">FM WhatsApp</a></li>
            <li><a href="/jt-whatsapp/">JT WhatsApp</a></li>
            <li><a href="/yo-whatsapp/">YoWhatsApp</a></li>
            <li><a href="/og-whatsapp/">OG WhatsApp</a></li>
            <li><a href="/red-whatsapp/">Red WhatsApp</a></li>
          </ul>
        </li>
        <li class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33 header-download">
          <a href="/download/" class="download-btn">Download</a>
        </li>
      </ul>
    </div>
  </div>
</nav>
<!-- 全站面包屑 -->
<Breadcrumb />
</div>
</template>

<script>
import Search from './Search.vue';
import Breadcrumb from './Breadcrumb.vue';
export default {
  components: {
    Search,
    Breadcrumb,
  },
  props: {
    selectedLanguage: {
      type: String,
      required: true,
    },
    page: {
      type: String,
      required: true,
    },
    gotodownload: {
      type: Function,
    },
    apk: {
      type: Object,
    },
  },
  data() {
    return {
      isHovered: false,
      isMenuClicked: false,
      isModClicked: false,
      isModOpen: false,
      isSearchClicked: false,
      lang: [{
          lang: 'en',
          val: '🇺🇸 English'
        },
        {
          lang: 'ar',
          val: '🇦🇪 اَلْعَرَبِيَّةُ'
        },
        {
          lang: 'id',
          val: '🇮🇩 Bahasa Indonesia'
        },
        {
          lang: 'pt',
          val: '🇵🇹 Português'
        },
        {
          lang: 'es',
          val: '🇪🇸 Español'
        },
        {
          lang: 'hi',
          val: '🇮🇳 हिंदी'
        },
      ],
      translation: {
        en: {
          home: 'Home',
          download: 'Download',
          blogs: 'Blogs',
          mod: 'WhatsApp Mods',
        },
        ar: {
          home: 'الصفحة الرئيسية',
          download: 'تحميل',
          blogs: 'المدونات',
          mod: 'مودات واتس اب',
        },
        id: {
          home: 'Beranda',
          download: 'Unduh',
          blogs: 'Blog',
          mod: 'Mod WhatsApp',
        },
        pt: {
          home: 'Casa',
          download: 'Baixar',
          blogs: 'Blogs',
          mod: 'Mods do WhatsApp',
        },
        es: {
          home: 'Casa',
          download: 'Descargar',
          blogs: 'Blogs',
          mod: 'Mods de WhatsApp',
        },
        hi: {
          home: 'घर',
          download: 'डाउनलोड',
          blogs: 'ब्लॉग',
          mod: 'व्हाट्सएप मोड्स',
        },
      },
    }
  },
  watch: {
    isSearchClicked(newVal) {
      if (!newVal) {
        this.$refs.searchComponent?.resetSearch();
      }
    }
  },
  methods: {
    changeLanguage(lang) {
      console.log("changelang: ", lang);
      console.log("page: ", this.page);
      this.$router.push({
        name: `${this.selectedLanguage}-${this.page}`
      });
    },
  },
}
</script>

<style lang="scss" scoped>
.site-header-wrap {
  width: 100%;
}

#site-navigation {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);

  .inside-navigation {
    width: 80%;
    margin: 0 auto;
    z-index: 9999;
    position: relative;
  }
}

#backtop {
  width: 30px;
  height: 30px;
  position: fixed;
  right: 50px;
  bottom: 100px;
  background: #f0f0f0;
  padding: 10px;
  border-radius: 50%;
  box-sizing: content-box;

  svg {
    display: block;
    width: 100%;
    height: 100%;
  }
}

/* 一级导航：字号、字重与全局 .main-navigation 一致，避免「MOD Apps」视觉上偏大 */
.main-nav {
  .menu {
    list-style-type: none !important;
    margin: 0 !important;

    > li > a {
      font-size: 16px !important;
      font-weight: 400 !important;
    }
  }
}

/* PC 下拉菜单 */
.has-dropdown {
  position: relative;

  .dropdown-menu {
    display: none;
    position: absolute;
    top: 100%;
    left: 0;
    background: #fff;
    border-radius: 6px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
    min-width: 160px;
    list-style: none !important;
    margin: 0 !important;
    padding: 5px 0;
    z-index: 9999;

    li {
      margin: 0 !important;

      a {
        display: block;
        padding: 5px 14px;
        line-height: calc(1.5em + 10px);
        color: #333 !important;
        font-size: 14px;
        white-space: nowrap;
        text-decoration: none;
        transition: background 0.15s, color 0.15s;

        &:hover {
          background: var(--brand-primary-soft, #e8fff1);
          color: var(--brand-primary, #06c755) !important;
        }
      }
    }
  }

  &:hover .dropdown-menu {
    display: block;
  }
}

/* 下拉项默认深色，仅鼠标指到该选项时变蓝（压过全局 li:hover > a 的青色） */
#site-navigation.main-navigation .main-nav .dropdown-menu li > a {
  color: #303030 !important;
}
#site-navigation.main-navigation .main-nav .dropdown-menu li > a:hover {
  color: var(--brand-primary, #06c755) !important;
}

/* 空心箭头：仅用边框构成 V 形；收起时朝下，展开时旋转朝上 */
.arrow-hollow {
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-left: 6px;
  margin-bottom: 3px;
  vertical-align: middle;
  border-right: 2px solid currentColor;
  border-bottom: 2px solid currentColor;
  transform: rotate(45deg);
  transform-origin: 50% 50%;
  box-sizing: border-box;
  border-top: none;
  border-left: none;
  background: transparent;
  transition: transform 0.25s ease, margin-bottom 0.25s ease;
}

/* PC：悬停展开下拉时箭头翻转为朝上 */
.has-dropdown:hover > a .arrow-hollow {
  transform: rotate(-135deg);
  margin-bottom: 0;
}

/* 移动端：子菜单展开时箭头同上 */
.mod-dropdown-open > a .arrow-hollow {
  transform: rotate(-135deg);
  margin-bottom: 0;
}

/* 移动端子菜单 */
.mobile-sub-menu {
  list-style: none !important;
  margin: 0 !important;
  padding: 0;
  background: #f5f5f5;

  li {
    margin: 0 !important;

    a {
      display: block;
      padding: 5px 0;
      line-height: calc(1.5em + 10px);
      font-size: 14px !important;
      color: #555 !important;
      text-align: center;
      transition: color 0.15s, background 0.15s;

      &:hover {
        color: var(--brand-primary, #06c755) !important;
        background: #eee;
      }
    }
  }
}

@media screen and (max-width: 768px) {

  .inside-navigation {

    .mobile-menu-page {
      position: absolute;
      top: 100%;
      width: 100%;
      z-index: 1001;
      margin: 0 !important;

      .menu-item {
        padding: 14px 0;
        margin-bottom: 0 !important;
        background: #fff;

        a, div {
          font-size: 15px;
          text-align: center;
          color: #121212;
          display: block;
        }
      }
    }
  }

  .main-nav {
    flex: 1;
    margin-right: 10px;

    .mobile-menu {
      display: flex;
      justify-content: flex-end;
      position: relative;

      .language-selector {
        width: 60%;

        #language-select {
          width: 100%;
        }
      }

      .menu-toggle {
        display: block;
        display: flex;
        justify-content: center;
        padding: 12px 12px;
        margin-bottom: 0;

        img {
          width: 23px;
          height: 23px;
        }
      }

      .search-toggle {
        display: block;
        padding: 12px 12px;
        display: flex;
        justify-content: center;
        margin-bottom: 0;

        img {
          width: 23px;
          height: 23px;
        }
      }
    }
  }
}
</style>
